module.exports = __webpack_public_path__ + "img/redo.d703d574.svg";